import { captureEvent } from './browser';
import type { EventMap, EventName } from './events';

/**
 * Typed capture — the property shape is enforced per event name by `EventMap`
 * (legacy V2 events + the registry). Stable module-level function, safe to use
 * directly in effects/handlers without triggering re-renders.
 */
export function capture<K extends EventName>(event: K, properties: EventMap[K]): void {
  captureEvent(event, properties as Record<string, unknown>);
}

/** React-idiomatic accessor returning the typed `capture` helper. */
export function useAnalytics(): { capture: typeof capture } {
  return { capture };
}
